import { Roles } from '../../../cimsPage/instances/admin'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const roles = CreateViewEditSoftRemoveRestore({
  page: Roles,
  object: 'Role',
  create: 'a7456a35-8061-4890-ad06-ff3270df1358',
  view: 'b0451d72-d402-402e-b66f-326ba1925529',
  edit: '82d7dd29-6e2b-449f-b274-26fb144f99c7',
  removeRestore: 'e7bf4f27-cbf4-45b2-899d-6aeefc9b9c24',
})

export const CreateRole = roles.Create
export const ViewRole = roles.View
export const EditRole = roles.Edit
export const RemoveRestoreRole = roles.RemoveRestore

export type RolePermission =
  | typeof CreateRole
  | typeof ViewRole
  | typeof EditRole
  | typeof RemoveRestoreRole
